import axios from 'axios'
const TEST_URL = 'http://localhost:8080'
const TEST_ENV_URL = "http://springboottesting.j.layershift.co.uk";
const LIVE_URL = "https://sitereporting.dandara.com/"
export default axios.create({
    baseURL:LIVE_URL,
    headers:{
        'Content-Type': 'application/json'
    }
});

